
<div class="report-page-root-container master-sales-report-component-container">
  <div class="page-content">
    <div class="page-header">
      <img class="icon" src="assets/images/menu/svg/master-sales-report.svg" width="27" />
      <div class="title">
        {{ title }}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">

            <div class="row">
              <mat-form-field>
                <mat-label>Period From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY" />
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.hasError('required') && editForm.get('period_from')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Period To</mat-label>
                <input matInput [matDatepicker]="pickerTo" formControlName="period_to"
                  [min]="editForm.get('period_from')?.value" placeholder="DD-MM-YYYY" />
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_to')?.hasError('required') && editForm.get('period_to')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="list-row order-source">
              <div class="header" (click)="isExpandedOrder = !isExpandedOrder">
                <div class="title-container">
                  <span class="title">Order Source</span> <span class="count" *ngIf="selectedOrderSourcesCount>0">[
                    {{selectedOrderSourcesCount}} ] </span>
                </div>

                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedOrder">
                    <button type="button" class="list-action-button"
                      (click)="$event.stopPropagation(); showSelectedOrderOnly = !showSelectedOrderOnly"
                      [matTooltip]="showSelectedOrderOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedOrderOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllOrder()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconOrder() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedOrder ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>

                </div>
              </div>
              <div *ngIf="isExpandedOrder" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter order sources" formControlName="orderSourceFilter" />
                      <button *ngIf="editForm.get('orderSourceFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('orderSourceFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredOrderSourceListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{ item.item.name }}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Shop Dropdown -->
            <div class="list-row shop">
              <div class="header" (click)="isExpandedShop = !isExpandedShop">
                <div class="title-container">
                  <span class="title">Shops</span> <span class="count" *ngIf="selectedShopSourcesCount>0">[
                    {{selectedShopSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedShop">
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); showSelectedShopOnly = !showSelectedShopOnly"
                      [matTooltip]="showSelectedShopOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedShopOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllShop()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconShop() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedShop ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedShop" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter shops" formControlName="shopFilter" />
                      <button *ngIf="editForm.get('shopFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('shopFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredShopListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{ item.item.name }}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Region Dropdown -->
            <div class="list-row region">
              <div class="header" (click)="isExpandedArea = !isExpandedArea">
                <div class="title-container">
                  <span class="title">Region</span> <span class="count" *ngIf="selectedAreaSourcesCount>0">[
                    {{selectedAreaSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedArea">
                    <button type="button" class="list-action-button"
                      (click)="$event.stopPropagation(); showSelectedAreaOnly = !showSelectedAreaOnly"
                      [matTooltip]="showSelectedAreaOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedAreaOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllRegion()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconRegion() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedArea ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>

                </div>
              </div>
              <div *ngIf="isExpandedArea" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter regions" formControlName="regionFilter" />
                      <button *ngIf="editForm.get('regionFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('regionFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredAreaListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{ item.item.name }}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Department Dropdown -->
            <div class="list-row department">
              <div class="header" (click)="isExpandedDepartment = !isExpandedDepartment">
                <div class="title-container">
                  <span class="title">Department</span> <span class="count" *ngIf="selectedDepartmentSourcesCount>0">[
                    {{selectedDepartmentSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedDepartment">
                    <button type="button" class="list-action-button"
                      (click)="$event.stopPropagation(); showSelectedDepartmentOnly = !showSelectedDepartmentOnly"
                      [matTooltip]="showSelectedDepartmentOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedDepartmentOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllDepartment()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconDepartment() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <svg *ngIf="!isExpandedDepartment" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" fill="none" />
                    </svg>
                    <svg *ngIf="isExpandedDepartment" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="2" fill="none" />
                    </svg>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedDepartment" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter departments" formControlName="departmentFilter" />
                      <button *ngIf="editForm.get('departmentFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('departmentFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredDepartmentListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{ item.item.name }}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Group Dropdown -->
            <div class="list-row main-group">
              <div class="header" (click)="isExpandedMainGroup = !isExpandedMainGroup">
                <div class="title-container">
                  <span class="title">Main Group</span> <span class="count" *ngIf="selectedMainGroupSourcesCount>0">[
                    {{selectedMainGroupSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedMainGroup">
                    <button type="button" class="list-action-button"
                      (click)="$event.stopPropagation(); showSelectedMainGroupOnly = !showSelectedMainGroupOnly"
                      [matTooltip]="showSelectedMainGroupOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedMainGroupOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllMainGroup()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconMainGroup() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedMainGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>

                </div>
              </div>
              <div *ngIf="isExpandedMainGroup" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter main groups" formControlName="mainGroupFilter" />
                      <button *ngIf="editForm.get('mainGroupFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('mainGroupFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredMainGroupListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{ item.item.name }}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Group Dropdown -->
            <div class="list-row group-form">
              <div class="header" (click)="isExpandedGroup = !isExpandedGroup">

                <div class="title-container">
                  <span class="title">Group</span> <span class="count" *ngIf="selectedGroupSourcesCount>0">[
                    {{selectedGroupSourcesCount}} ] </span>
                </div>

                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedGroup">
                    <button type="button" class="list-action-button"
                      (click)="$event.stopPropagation(); showSelectedGroupOnly = !showSelectedGroupOnly"
                      [matTooltip]="showSelectedGroupOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedGroupOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllGroup()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconGroup() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>

                </div>
              </div>
              <div *ngIf="isExpandedGroup" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter groups" formControlName="groupFilter" />
                      <button *ngIf="editForm.get('groupFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('groupFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredGroupListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{ item.item.name }}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Item Dropdown -->
            <div class="list-row item">
              <div class="header" (click)="isExpandedItem = !isExpandedItem">
                <div class="title-container">
                  <span class="title">Item</span> <span class="count" *ngIf="selectedItemSourcesCount>0">[
                    {{selectedItemSourcesCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedItem">
                    <button type="button" class="list-action-button"
                      (click)="$event.stopPropagation(); showSelectedItemOnly = !showSelectedItemOnly"
                      [matTooltip]="showSelectedItemOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedItemOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button"
                      (click)="$event.stopPropagation(); toggleSelectAllItem()" matTooltip="Select All">
                      <mat-icon>{{ getSelectAllIconItem() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedShop ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>

                </div>
              </div>
              <div *ngIf="isExpandedItem" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter items" formControlName="itemFilter" />
                      <button *ngIf="editForm.get('itemFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('itemFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredItemListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{ item.item.name }}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sort Dropdown -->
         
                <div class="row">
                  <mat-form-field appearance="fill">
                    <mat-label>Sort By</mat-label>
                    <mat-select formControlName="sortBy">
                      <mat-option value="total">Amount Sold</mat-option>
                      <mat-option value="qty">Qty Sold</mat-option>
                      <mat-option value="sale_item_name">Item Name</mat-option>
                      <mat-option value="gp">Gross Profit</mat-option>
                      <mat-option *ngIf="editForm.get('showDepGrpMainGrp')?.value"
                        value="department_name">Departments</mat-option>
                      <mat-option *ngIf="editForm.get('showDepGrpMainGrp')?.value" value="super_class_name">Main
                        Group</mat-option>
                      <mat-option *ngIf="editForm.get('showDepGrpMainGrp')?.value"
                        value="sub_class_name">Group</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Sort Order</mat-label>
                    <mat-select formControlName="orderBy">
                      <mat-option value="asc">Ascending</mat-option>
                      <mat-option value="desc">Descending</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              

            <!-- Checkboxes -->
            <mat-checkbox formControlName="includeShopDetails">
              Include Shop Details
            </mat-checkbox>
            <mat-checkbox formControlName="showDepGrpMainGrp">
              Show Department/MainGroup/Group
            </mat-checkbox>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>